import React from "react";
import ReactDOM from "react-dom/client";

import "@/app/globals.css";
import "@/i18n";
import "@/libs/axios";
import "@/libs/sentry";
import { Auth0Provider } from "@auth0/auth0-react";

import App from "./app/pages";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        // scope: "read:current_user update:current_user_metadata",
        audience: `https://${import.meta.env.VITE_AUTH0_DOMAIN}/api/v2/`,
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
